import { api } from "@/lib/api";


export const getPublicLegal = (type) => api.get(`/legal/${type}`).then((r) => r.data, (e) => Promise.reject(e?.response?.status));
export const getLegalDoc = (type) => api.get(`/admin/legal/${type}`).then((r) => r.data);
export const getLegalVersion = (type, id) => api.get(`/admin/legal/${type}/versions/${id}`).then((r) => r.data);
export const saveLegalDraft = (type, body) => api.put(`/admin/legal/${type}/draft`, body).then((r) => r.data);
export const publishLegal = (type, kind) => api.post(`/admin/legal/${type}/publish`, { kind }).then((r) => r.data);

export const fmtDate = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00:00`).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" }) : "");
